module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlatinum.a60f5d2.webp";